/*global $, veloxScriptLoader, VeloxWebView, VeloxServiceClient, VeloxViewController, VeloxFormController, VeloxAppController, VeloxGridAndFormController, VeloxImporterController, mocha */


var offlineRuntime = require('offline-plugin/runtime');

//hide splash
var splashcreen = document.getElementById("loader") ;


function installOffline(){
    if(window.native){
        return; //no offline on mobile and desktop
    }
    var quotaNeeded = 50000000;
    var estimateStorage = function(callback){
        return callback({usage: 0, quota: quotaNeeded*2}) ;
    } ;
    if(navigator.storage && navigator.storage.estimate){
        estimateStorage = function(callback){
            navigator.storage.estimate().then(function(usage){
                callback(usage) ;
            });
        } ;
    }else if ('webkitTemporaryStorage' in navigator && typeof navigator.webkitTemporaryStorage.queryUsageAndQuota === 'function') {
        estimateStorage = function(callback){
            navigator.webkitTemporaryStorage.queryUsageAndQuota(function(usage, quota) {
                callback({usage: usage, quota: quota});
            });
        } ;
    }
    
    estimateStorage(function(usage){ 
        if(usage.quota - usage.usage < quotaNeeded){
            //not enough storage, don't install offline
            console.log("not enough storage, remove service workers to force last version", usage.quota, usage.usage) ; 
            if(navigator.serviceWorker && navigator.serviceWorker.getRegistrations){
                navigator.serviceWorker.getRegistrations().then(function(registrations) {
                    registrations.forEach(function(registration){
                        registration.unregister();
                    }) ;
                }) ;
            }
            return ;
        }
        offlineRuntime.install({
            onUpdating: function() {
            console.log('SW Event:', 'onUpdating', splashcreen.className);
            splashcreen.className += " updating" ;
            },
            onUpdateReady: function() {
            console.log('SW Event:', 'onUpdateReady');
            // Tells to new SW to take control immediately
            offlineRuntime.applyUpdate();
            },
            onUpdated: function() {
            console.log('SW Event:', 'onUpdated');
            // Reload the webpage to load into the new version
            window.location.reload();
            },
        
            onUpdateFailed: function() {
            console.log('SW Event:', 'onUpdateFailed', splashcreen.className);
            splashcreen.className.replace(/updating/g, "") ;
            },
            onInstalled:function() {
            console.log('SW Event:', 'onInstalled', splashcreen.className);
            }
        });
        try{
            if(navigator.serviceWorker && navigator.serviceWorker.getRegistrations){
                navigator.serviceWorker.getRegistrations().then(function(registrations) {
                    registrations.forEach(function(registration){
                        console.log("SW Event: Check SW update") ;
                        try{
                            registration.update().catch(function(e){
                                console.log("SW Event: Check update failed", e) ;
                            });
                        }catch(e){
                            console.log("SW Event: Check update failed", e) ;
                        }
                    }) ;
                }).catch(function(e){
                    console.log("SW Event: Check update failed", e) ;
                }) ;
            }
        }catch(e){
            console.log("SW Event: Check update failed", e) ;
        }
    }) ;

}

var libs = require("./config/libs") ;
var libsDatatables = require("./config/libsDatatables") ;
var pkg = require("../package.json") ;
//

veloxScriptLoader.setOptions({
    policy: "npm",
    npmPath: "node_modules"
}) ;


var libsToLoad = libs ;
if(process.env.MODE === "development"){
    var libsTest = require("./config/libsTest") ;
    libsToLoad = libsToLoad.concat(libsTest);
}

veloxScriptLoader.load(libsToLoad, function(err){
    if(err){ return alert("Can't load view library "+JSON.stringify(err)) ;}


    

    //Bootstrap 4 extension (should put in external extension)
    VeloxWebView.registerExtension({
        name: 'bootstrap-4',
        init: function(){
            var view = this;
            view.on("render", function(){
                $(view.EL.bootstrapContents).scrollspy({ target: view.EL.spy }) ;
                $(view.viewRootEl).find('[data-toggle="tooltip"]').tooltip() ;
            });
        }
    });

    var objectsToInject = {} ;

    var confCalls = [] ;

    var i18nConfiguration = require("./config/i18n") ;
    if(i18nConfiguration){
        confCalls.push(function(cb){
            VeloxWebView.i18n.configure(i18nConfiguration, cb) ;
        }) ;
    }


    var apiConfiguration = require("./config/apiConfig") ;
    if(apiConfiguration){
        confCalls.push(function(cb){
            var api = new VeloxServiceClient(apiConfiguration) ;

            objectsToInject.api = api ;
    
            api.addEndPoints(require("./config/endpoints.js")) ;
    
            var onerror = function (error) {
                if(window.runningTest){
                    return; //don't catch error in test mode
                }
                if(error && error.reason instanceof Error){
                    //case of error happen in promise
                    error.message = error.reason.message ;
                    error.error = error.reason ;
                }
                var msg = "";
                try{
                    msg = error.message ;
                    if(error.error){
                        var stack = error.error.stack ;
                        if(stack){
                            msg += "\n"+stack ;
                        }
                    }
                    var unexpectedErrorMsg = VeloxWebView.tr("global.unexpectedError") ;
                    VeloxWebView.error(unexpectedErrorMsg+"\n"+msg) ;
                    
                }catch(err){
                    console.log("error while display unexpected error message...", err, error) ;						
                }
                try{
                    var report = {
                        app_name : pkg.name,
                        app_version: pkg.version,
                        date : new Date(),
                        user_agent: window.navigator.userAgent,
                        url: window.location.href,
                        error: msg
                    } ;
                    api.saveCrashReport(report, function(err){
                        if(err){
                            console.log("error while sending crash report") ;
                        }
                    }) ;
                }catch(err){
                    console.log("error while sending crash report...", err, error) ;						
                }
                return false;

            } ;

            window.addEventListener("error", onerror ) ;
            window.addEventListener("unhandledrejection", onerror ) ;


            //init api
            api.init(function(err){
                if(err){ 
                    return VeloxWebView.error(err);
                }
    
                
                api.api.syncSchema(function(err){
                    if(err){ 
                        console.log("Can't sync schema", err) ;
                    }
                    api.api.getSchema(function(err, schema){
                        if(err){ 
                            return VeloxWebView.error(err);
                        }

                        if(VeloxWebView.fieldsSchema){
                            VeloxWebView.fieldsSchema.configure({
                                schema: schema, 
                                apiClient: api,
                            //    schemaExtend: schemaExtends,
                                addLabelToFields : true,
                                addErrorsToFields : true
                            }) ;
                        }

                        if(VeloxWebView.fields){
                            VeloxWebView.fields.configure({
                                apiClient: api, 
                            }) ;
                        }


                        cb() ;
                    }) ;
                }) ;
            }) ;    
        }) ;
    }


    confCalls.push(function(cb){
        if(VeloxServiceClient.setOfflineBinaryStorageEngine && window.native && window.native.binaryStorage){
            VeloxServiceClient.setOfflineBinaryStorageEngine(window.native.binaryStorage);
        }
        cb() ;
    }) ;

    VeloxWebView._asyncSeries(confCalls, function(err){
        if(err){ 
            return VeloxWebView.error(err);
        }

        VeloxViewController.setDefaultContainerParent("views") ;

        //load the bootstrap theming for datatable after datatable file are loaded
        veloxScriptLoader.addLoadListener("datatables-select-js", function(done){
            veloxScriptLoader.load(libsDatatables, function(err){
                if(err){ return done(err) ;}
                window.jQuery.extend( true, window.jQuery.fn.dataTable.Buttons.defaults, {
                    dom: {
                            container: {
                                    className: 'btn-group mr-2'
                            },
                            button: {
                                    className: 'btn btn-sm btn-outline-secondary'
                            },
                            collection: {
                                    tag: 'div',
                                    className: 'dt-button-collection dropdown-menu',
                                    button: {
                                            tag: 'a',
                                            className: 'dt-button dropdown-item',
                                            active: 'active',
                                            disabled: 'disabled'
                                    }
                            }
                    }
                } );
                
                window.jQuery.extend( true, window.jQuery.fn.dataTable.defaults, {
                    language: {
                        buttons: {
                            colvis: '&nbsp;<i class="fas fa-bars"></i>',
                            copy: '<i class="far fa-copy"></i>',
                            excel: '<i class="far fa-file-excel"></i>',
                            pdf:'<i class="far fa-file-pdf"></i>',
                            print:'<i class="fas fa-print"></i>'

                        }
                    },
                    dom:
                        "<'row'<'col-xs-12 col-sm-6 col-md-6 d-flex flex-row'lB><'col-xs-12 col-sm-6 col-md-6 mt-2'f>>" +
                        "<'dt-table'tr>" +
                        "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
                } );
                done();
            }) ;
        }) ;

        

        VeloxWebView.fields.addDecorator(function bootstrap4decorator(element, fieldType){
            if(fieldType === "select" || fieldType === "selection" || fieldType === "multiple"){
                var selectMultiple = element.querySelector(".select-multiple-container") ;
                if(selectMultiple){
                    selectMultiple.className += " form-group form-control" ;
                }else{
                    var select = element.getElementsByTagName("select")[0] ;
                    select.className += " form-group form-control" ;
                }
                return ;
            }
            
            if(fieldType === "textarea"){
                var textarea = element.getElementsByTagName("textarea")[0] ;
                element.className += " form-group" ;
                textarea.classList.add("form-control") ;
                return ;
            }
            if(fieldType === "radio" || fieldType === "checkboxes"){
                var inputs = Array.prototype.slice.apply(element.getElementsByTagName("input")) ;
                var isInline = element.hasAttribute("data-inline") ;
                for(var i=0; i<inputs.length; i++){
                    var input = inputs[i] ;
                    var label = input.nextSibling ;
                    input.className += " form-check-input";
                    label.className += " form-check-label";
                    var div = document.createElement("DIV") ;
                    div.className = "form-check" ;
                    if(isInline){
                        div.className += " form-check-inline" ;
                    }
                    div.appendChild(input);
                    div.appendChild(label);
                    element.appendChild(div) ;
                }
                return ;
            }
            if(fieldType === "upload" || fieldType === "pdf"){
                return;
            }
            if(fieldType === "grid" ){
                var tables = element.getElementsByTagName("table") ;  
                for(var i=0; i<tables.length; i++){
                    tables[i].className += " table table-striped table-bordered table-hover dt-responsive nowrap" ;
                }
                var refreshButton = element.querySelector(".table-custom-button-refresh") ;
                if(refreshButton){
                    refreshButton.innerHTML = '&nbsp;<i class="fas fa-sync"></i>&nbsp;' ;
                }
                var createButton = element.querySelector(".table-custom-button-createNew") ;
                if(createButton){
                    createButton.className = createButton.className.replace("btn-outline-secondary", "btn-primary") ;
                }
                return;
            }

            var input = element.getElementsByTagName("input")[0] ;
            if(input){
                if(input.type === "checkbox"){
                    if(fieldType !== "toggle"){
                        element.className += " form-check" ;
                        var label = element.getElementsByTagName("label")[0] ;
                        if(label){
                            label.className += " form-check-label" ;
                        }
                        input.className += " form-check-input";
                    }
                }else{
                    element.className += " form-group" ;
                    input.className += " form-control" ;
                }
            }else{
                element.className += " form-group" ;
                
            }

            var pickerMobile = element.querySelector(".flatpickr-mobile") ;
            if(pickerMobile){
                pickerMobile.className += " form-control" ;
            }
            
            
        }) ;

        if(VeloxFormController){
            VeloxFormController.setOptions({
                buttonsHTML: require("./views/global/form-buttons.html"),
                formAttributes: { novalidate: ""}
            }) ;
        }

        if(VeloxImporterController){
            VeloxImporterController.setOptions({
                decorator: function(viewCompiled){
                    viewCompiled.xmlDoc.querySelector(".velox-importer-choose-file").className += " btn btn-outline-primary" ;
                    viewCompiled.xmlDoc.querySelector(".velox-importer-choose-start").className += " btn btn-primary" ;
                    
                    viewCompiled.xmlDoc.querySelector(".velox-importer-header-checkbox").className += " form-check form-check-inline" ;
                    viewCompiled.xmlDoc.querySelector(".velox-importer-header-checkbox input").className += " form-check-input" ;
                    viewCompiled.xmlDoc.querySelector(".velox-importer-header-checkbox label").className += " form-check-label" ;
                }
            }) ;
        }

        // var loginController = require("./controllers/loginController") ;

        var app = new VeloxAppController() ;
        window.app = app ;
        app.context = { controllers: {}} ;
        Object.keys(objectsToInject).forEach(function(k){
            app.context[k] = objectsToInject[k] ;
            app.injectToControllers(k, objectsToInject[k]) ;
        }) ;

        var requireControllers = require.context("./controllers", true, /^\.\/.*\.js$/) ;

        requireControllers.keys().forEach(function(c){
            var controller = requireControllers(c);
            app.context.controllers[c.match(/([a-zA-Z0-9]+)\.js$/m)[1]] = controller ;
            app.registerController(controller) ;
        });

        var callsStartup = [] ;

        var requireInterceptors = require.context("./interceptors", true, /^\.\/.*\.js$/) ;

        requireInterceptors.keys().forEach(function(c){
            var interceptors = requireInterceptors(c);
            interceptors.forEach(function(interceptor){
                if(interceptor.type === "ajax"){
                    app.context.api.addAjaxInterceptor(function(err, request, response, next){
                        interceptor.interceptor(app, err, request, response, next) ;
                    }) ;
                }else if(interceptor.type === "navigation"){
                    app.addInterceptor(function(context, next){
                        console.log("RUN INTERCEPTOR", interceptor);
                        interceptor.interceptor(app,context, function(){
                            console.log("DONE INTERCEPTOR", interceptor);
                            next() ;
                        }) ;
                    }) ;
                }else if(interceptor.type === "startup"){
                    callsStartup.push(function(cb){
                        interceptor.interceptor(app, cb) ;
                    }) ;
                }else{
                    VeloxWebView.error("unkown interceptor type "+interceptor.type);
                }
            }) ;
        });

        var requireExtensions = require.context("./extensions", true, /^\.\/.*\.js$/) ;

        requireExtensions.keys().forEach(function(c){
            var extension = requireExtensions(c);
            VeloxWebView.registerExtension(extension);
        });

        VeloxWebView._asyncSeries(callsStartup, function(err){
            if(err){ 
                return VeloxWebView.error(err);
            }

            //hide splash
            splashcreen.addEventListener("transitionend", function(){
                splashcreen.className += " hide-done" ;
                setTimeout(function(){
                    splashcreen.parentElement.removeChild(splashcreen);
                }, 2000) ;
            }) ;
            splashcreen.className += " hide" ;

            app.navigate() ;
            installOffline() ;
            if(process.env.MODE === "development"){
                var runTest = null;
                if(window.location.search){
                    var params = window.location.search.substring(1).split("&") ;
                    params.forEach(function(paramPair){
                        var param = paramPair.split("=") ;
                        if(param[0] === "runTest"){
                            runTest = param[1] ;
                        }
                    });
                }
                if(runTest){
                    window.runningTest = true ;
                    var divMocha = document.createElement("DIV") ;
                    divMocha.id = "mocha" ;
                    divMocha.style.position = "absolute" ;
                    divMocha.style.top = 0 ;
                    divMocha.style.bottom = 0 ;
                    divMocha.style.left = 0 ;
                    divMocha.style.right = 0 ;
                    divMocha.style.backgroundColor = "rgba(255, 255, 255, 0.81)" ;
                    divMocha.style.display = "none" ;
                    divMocha.style.zIndex = 999999 ;
                    document.body.appendChild(divMocha) ;
                    window.controllers = {} ;
                    app.controllers.forEach(function(ct){
                        if(ct.viewOptions){
                            window.controllers[ct.viewOptions.name] = ct ;
                        }else if (ct instanceof VeloxGridAndFormController){
                            window.controllers[ct.table] = ct ;
                        }
                    }) ;
                    mocha.setup('bdd') ;
                    var testsToRun = [] ;
                    if(runTest === "all"){
                        var requireTests = require.context("../tests", true, /^\.\/.*\.js$/) ;

                        testsToRun = requireTests.keys().map(function(t){ return "tests/"+t.replace(/^\.\//, "") ;}) ;
                    }else{
                        testsToRun = runTest.split(",").map(function(t){ return "tests/"+t+".js" ;}) ;
                    }
                    veloxScriptLoader.load(testsToRun.map(function(t){
                        return {
                            name: t,
                            type: "js",
                            version: 1,
                            localPath: t
                        } ;
                    }), function(){
                        mocha.checkLeaks();
                        mocha.globals(["JSZip", "__core-js_shared__", "pdfMake", "createPdf", "Inputmask", "Decimal"]) ;
                        mocha.run(function(){
                            console.log("finished") ;
                            divMocha.style.display = "block" ;
                            var mochaStats = divMocha.querySelector("#mocha-stats") ;
                            if(mochaStats){
                                mochaStats.style.zIndex = 9999;
                                mochaStats.style.backgroundColor = "white";
                            }
                        });
                    });
                }
            }
        });
                
        


    }) ;
}) ;